import React from "react"
import { uniq, max, find, times, clone } from "lodash"
import { ButtonGroup, Button } from "react-bootstrap"
import Json from "react-json-view"
import {parse} from "query-string"
import moment from 'moment'

import ReservationsTable from "./tables/ReservationsTable"
import PerDayStats from "./tables/PerDayStats"
import MultilineChart from "./MultilineChart"

import {partners} from "../../../../data"

import "./tables/tables.less"
import "./PartnerInfo.less"

class PartnerPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: null,
      error: null,
      month: null,
    }
  }

  prepareGraphData() {
    const {reservations} = this.state.data
    const quantityArray = [];

    const monthDate = moment(this.state.month, 'YYYY/MM').startOf('month')

    times(monthDate.daysInMonth(), () => {
      quantityArray.push({x: monthDate.format('D'), y: 0})
      monthDate.add(1, 'day')
    })

    const priceArray = clone(quantityArray)

    const monthReservations = reservations.filter(res => moment(this.state.month, 'YYYY/MM').isSame(res.day, 'month'))

    monthReservations.forEach(res => {
      const day = moment(res.day).date()
      const quantityDay = quantityArray[day - 1]
      const priceDay = priceArray[day - 1]
      quantityArray[day - 1] = {...quantityDay, y: quantityDay.y + 1}
      priceArray[day - 1] = {...priceDay, y: priceDay.y + res.eurPrice}
    })
    return [quantityArray, priceArray]
  }
  
  fetchData() {
    fetch(`/partnerData/${parse(this.props.location.search).key}`)
      .then(response => response.json())
      .then(data => {
        const month = (
          data.reservations.length > 0 
            ? max(data.reservations.map(r => r.day) || "1990-01-01").slice(0, 7) 
            : null
        )
        this.setState({ data, month })
        this.prepareGraphData()
      })
      .catch(error => {
        this.setState({ error: JSON.stringify(error) })
        console.error("FETCH ERROR")
        console.error(error)
      })
  }

  componentDidMount() {
    this.fetchData()
  }

  months() {
    return uniq(this.state.data.reservations.map(r => (r.day || "2018-06-01").slice(0, 7)))
  }

  getPartner() {
    return find(partners, { 
      name: this.props.match.params.partnerName, 
      key: parse(this.props.location.search).key
    })
  }

  render() {
    const partner = this.getPartner()
    
    /* ERRORES */
    if (!partner || !this.state.data) return (
      <h2>Loading...</h2>
    )

    if (this.state.error) return (
      <h2>Error</h2>
    )
    
    /* prepare data */
    
    const graphData = this.prepareGraphData()
    const maxima = graphData 
      ? graphData.map(
        (dataset) => Math.max(...dataset.map((d) => d.y))
      )
      : []

    /* AOK */

    const reservations = this.state.data.reservations
      .filter(r => (r.day || "2018-06-01").slice(0, 7) == this.state.month)

    console.log(reservations.map(r => r.timestamp))
    const filteredReservations = reservations.filter(r => r.day.startsWith(this.state.month))

    return (
      <div className="PartnerInfo">
        <h1>
          Sales from partner
          {' '}
          {partner.name}
          <img 
            src={partner.logo}
            style={{ height: 64, float: "right" }}
          />
        </h1>

        <ButtonGroup style={{ margin: 10 }}>
          {
            this.months().sort().map(month => (
              <Button key={month} 
                onClick={() => this.setState({ month })} 
                disabled={this.state.month == month}
              >
                {month}
              </Button>
            ))
          }
        </ButtonGroup>
        
        {
          graphData && (
            <MultilineChart graphData={graphData} />
          )
        }
        
        {
          graphData && (
            <PerDayStats graphData={graphData} reservations={reservations} month={this.state.month} />
          )
        }
        
        <ReservationsTable partnerMode reservations={filteredReservations} />

      </div>
    )
  }
}

export default PartnerPage


// WEBPACK FOOTER //
// ./src/app/admin/components/PartnerInfo.jsx